import React, { Component } from 'react';
import './BlurArea.css';

export default class extends Component {
  render() {
    let active = (this.props.active) ? 'active' : '';

    return (
      <div className={`blur-area ${active}`}>
      	{this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/BlurArea.js